import React from 'react';

import { FuelPanel } from './FuelPanel/FuelPanel';
import { LoadPanel } from './LoadPanel/LoadPanel';
import { PassengerPanel } from './PassengerPanel/PassengerPanel';
import { AdditionalInfoPanel } from './AdditionalInfoPanel/AdditionalInfoPanel';
import { TotalPanel } from './TotalPanel/TotalPanel';
import { useFieldsDeclaration } from '../../selectors/declaration';
import { useLanguage } from '../hooks/useLanguage/useLanguage';
import { useStyles } from './useStyles';

export const LoadingPage = () => {
    const { isEng } = useLanguage();
    const classes = useStyles(isEng)();
    const declaration = useFieldsDeclaration();

    return (
        <div className={classes.info}>
            <div className={classes.inner}>
                <div className={classes.fuel}>
                    <FuelPanel declaration={declaration} />
                    <AdditionalInfoPanel declaration={declaration} />
                </div>
                <TotalPanel declaration={declaration} />
            </div>
            <div className={classes.inner}>
                <PassengerPanel />
                <LoadPanel />
            </div>
        </div>
    );
};

LoadingPage.displayName = 'LoadingPage';
